import { Base64 } from './../../lib/helpers/utils';
import { Product, ProductHelper } from './product';

export enum BannerType {
    Articulos, Youtube, Imagen
}

export interface Banner {
    type: BannerType;
    products: Array<Product>;

    enlace: string;
    enlaceArticulo: boolean;
    id: string;
    titulo: string;
    zonaPantalla: string ;
    contents: string;
}


export class BannerHelper {

    static create(): Banner {
        return {
            type: BannerType.Articulos,
            products: [],
            enlace: '',
            enlaceArticulo: false,
            id: '',
            titulo: '',
            zonaPantalla: '',
            contents: '',
        };
    }

    static transformFromApi(apiData: Object, environment): Banner {

        // Banner Creation
        const banner = BannerHelper.create();
        banner.titulo = apiData['PO_TITULO'];
        banner.id = apiData['PO_ID'];
        banner.enlace = apiData['PO_ENLACE'];
        banner.enlaceArticulo = apiData['PO_ENLACE_ARTICULO'];
        banner.products = [];
        banner.contents = Base64.decode(apiData['PO_CONTENIDO']);

        // Imagen
        if (apiData['PO_TIPO'] === 'IMAGEN') {
            banner.type = BannerType.Imagen;
        }

        // Products
        if (apiData['PO_TIPO'] === 'ARTICULOS') {
            banner.type = BannerType.Articulos;
            const contentProducts = JSON.parse(banner.contents);
            banner.products = contentProducts.map(row => ProductHelper.transformFromApi(row, environment));
        }

        // Youtube
        if (apiData['PO_CONTENIDO'].indexOf('youtube') > 0) {
            banner.type = BannerType.Youtube;
            banner.contents = apiData['PO_CONTENIDO'];
            const aux = banner.contents.split('?')[1].split('&');

            for (const j in aux) {
                if (aux[j].indexOf('v=') === 0) {
                    banner.contents = 'http://www.youtube.com/embed/' + aux[j].split('v=')[1] + '';
                }
            }
        }

        return banner;
    }
}
